// Échappement minimal HTML : le libellé du partage est libre (jusqu'à 120
// caractères) et ne doit pas casser le document d'impression.
const escapeHtml = (value) =>
  String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

export const printQrCodeHTML = (logo, imgData, { title } = {}) => {
  const titleHtml = title
    ? `<h1 class="title">${escapeHtml(title)}</h1>`
    : "";
  return `
    <html>
    <head>
      <title>Print QR Code</title>
      <style>
        body {
          display: flex;
          flex-direction: column;
          justify-content: center; 
          align-items: center;
          height: 100vh; 
          margin: 0;
        }
        .logo {
          width: 100px;
          margin-bottom: 20px;
        }
        .title {
          font-family: sans-serif;
          font-size: 22px;
          margin: 0 0 12px 0;
          text-align: center;
        }
        .qrcode {
          margin-top: 20px; 
        }
      </style>
    </head>
    <body>
      <img className="logo" src="${logo}" alt="Logo" />
      ${titleHtml}
      <img className="qrcode" src="${imgData}"/>
    </body>
  </html>`;
};
